import React, { Component, useState, useEffect } from 'react';

import SelectDataset from '../SelectDataset';

const DatasetSelectEconomic = props => {

    const [reset, setReset] = useState(false);

    useEffect(() => {
        if (reset == true)
        {
            setReset(false);
        }
    }, [reset])

    const handleDatasetChange = (dataset, indicator, datasetLabel) => {
        props.handleDatasetByIndicator(dataset, indicator, datasetLabel);
    }

    const resetFilter = (e) => {
        e.preventDefault();
        setReset(true);
        props.resetFilter();
    }

    return (
        <React.Fragment>
            <ul className='select--dataset--list item5'>
                {/* Company Size Dataset */}
                <li className='item5-list'>
                    <label>{props.literals.L20065}</label>
                    <SelectDataset 
                        chart={'20089'}
                        indicator={'31'}
                        handleDatasetChange={handleDatasetChange}
                        reset={reset}
                    />
                </li>

                {/* Employment Per Sector Dataset */}
                <li className='item5-list'>
                    <label>{props.literals.L20066}</label>
                    <SelectDataset 
                        chart={'20010'}
                        indicator={'32'}
                        handleDatasetChange={handleDatasetChange}
                        reset={reset}
                    />
                </li>

                {/* Employment Rate Dataset */}
                <li className='item5-list'>
                    <label>{props.literals.L20067}</label>
                    <SelectDataset 
                        chart={'20011'}
                        indicator={'33'}
                        handleDatasetChange={handleDatasetChange}
                        reset={reset}
                    />
                </li>

                {/* GDP per capita Dataset */}
                <li className='item5-list'>
                    <label>{props.literals.L20068}</label>
                    <SelectDataset 
                        chart={'20013'}
                        indicator={'35'}
                        handleDatasetChange={handleDatasetChange}
                        reset={reset}
                    />
                </li>

                {/* Income per capita Dataset */}
                <li className='item5-list'>
                    <label>{props.literals.L20069}</label>
                    <SelectDataset 
                        chart={'20088'}
                        indicator={'279'}
                        handleDatasetChange={handleDatasetChange}
                        reset={reset}
                    />
                </li>
            </ul>
            <div className='dataset-filter-buttons'>
                <button className='btn-default btn-main-color' onClick={(e) => resetFilter(e)}>{ props.literals.L20628 }</button>
            </div>
        </React.Fragment>
    )
}

export default DatasetSelectEconomic;